import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { slingData } from 'src/components/template/compare/components/data/slingData'

export default (props) => <CompareTemplate location={props.location} data={slingData} />
